import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { JobFunction } from './job-function.interface';

export class JobFunctionService {
   async getJobFunctions(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<JobFunction>>(`/job-functions`, { params: { ...query } });
      const body = response.data as PaginatedResponse<JobFunction> & {
         meta?: { total?: number; per_page?: number; current_page?: number };
      };
      const data = Array.isArray(body?.data) ? body.data : [];
      const perPage = Number(body?.meta?.per_page ?? body?.per_page ?? query?.per_page ?? 25);
      const total = Number(body?.meta?.total ?? body?.total ?? data.length);
      const currentPage = Number(body?.meta?.current_page ?? body?.current_page ?? query?.page ?? 1);

      // Dropdown expects `{ data, meta: { total, per_page } }`; this endpoint returns flat pagination fields.
      return {
         data,
         meta: {
            ...(body?.meta ?? {}),
            total,
            per_page: perPage,
            current_page: currentPage,
            from: body?.from,
            to: body?.to,
         },
      };
   }
   async getJobFunction(jobFunctionId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<JobFunction>>(`/job-functions/${jobFunctionId}`, { params: { ...query } });
      return response.data;
   }
}
